import { Component, Input } from '@angular/core';
import { FormControl} from '@angular/forms';

@Component({
  selector: 'app-custom-input',
  standalone: false,
  templateUrl: './custom-input.component.html',
  styleUrl: './custom-input.component.scss',
})
export class CustomInputComponent {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() formControlName!: string;
  @Input() id: string = '';
  @Input() type: string = 'text';
  @Input() control!: FormControl;
}
